import React from "react";
import { Card, Row, Col } from "react-bootstrap";
import Footer from "../layouts/Footer";
import HeaderMobile from "../layouts/HeaderMobile";
import { useAuth } from '../utils/AuthContext';
import { Link } from 'react-router-dom';
import PayPalSubscription from '../components/subscription/PayPalSubscription';

export default function Pricing() {
  const { subscription } = useAuth();

  const features = [
    {
      name: "Basic Features",
      items: [
        "Expense Tracking",
        "Income Management", 
        "Basic Budget Tools",
        "Bill Reminders",
        "Basic Reports",
        "Mobile Access"
      ]
    },
    {
      name: "Premium Features",
      items: [
        "AI Financial Assistant",
        "Smart Expense Forecasting",
        "AI-Powered Insights",
        "Budget Optimization",
        "Debt Repayment Strategy",
        "Unlimited Categories",
        "Data Export",
        "Priority Support",
        "Advanced Analytics",
        "Goal Setting & Tracking"
      ]
    }
  ];

  return (
    <React.Fragment>
      <HeaderMobile />
      <div className="main main-pricing p-4 p-lg-5">
        <h3 className="pricing-title text-center mb-2">Choose your plan</h3>
        <p className="pricing-text text-center mb-4">Start with our free plan or unlock all features with Premium</p>

        <Row className="justify-content-center g-4">
          {/* Free Plan */}
          <Col md={5}>
            <Card className="card-pricing">
              <Card.Body className="p-4">
                <div className="pricing-header">
                  <h5>Free Plan</h5>
                  <h1 className="display-4 mb-0">$0</h1>
                  <p className="text-secondary">Forever free</p>
                </div>

                <div className="mt-4">
                  <h6 className="mb-3">Included Features:</h6>
                  <ul className="list-unstyled">
                    {features[0].items.map((feature, index) => (
                      <li key={index} className="d-flex align-items-center mb-2">
                        <i className="ri-checkbox-circle-line text-success me-2"></i>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>

                <Link 
                  disabled={true}
                  className="btn btn-outline-primary w-100 mt-3"
                >
                  Using
                </Link>
              </Card.Body>
            </Card>
          </Col>

          {/* Premium Plan */}
          <Col md={5}>
            <Card className="card-pricing border-primary">
              <Card.Body className="p-4">
                <div className="pricing-header">
                  <div className="d-flex align-items-center justify-content-center mb-3">
                    <h5 className="mb-0">Premium</h5>
                    <span className="badge bg-primary ms-2">RECOMMENDED</span>
                  </div>
                  <h1 className="display-4 mb-0">$2</h1>
                  <p className="text-secondary">per month</p>
                </div>

                <div className="mt-4">
                  <h6 className="mb-3">Everything in Free, plus:</h6>
                  <ul className="list-unstyled">
                    {features[1].items.map((feature, index) => (
                      <li key={index} className="d-flex align-items-center mb-2">
                        <i className="ri-checkbox-circle-line text-success me-2"></i>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>

                {subscription === 'premium' ? (
                  <Link 
                    to="/settings"
                    className="btn btn-primary w-100 mt-3"
                  >
                    Manage Subscription
                  </Link>
                ) : (
                  <PayPalSubscription 
                    onSuccess={() => {
                      // Handle successful subscription
                      window.location.reload();
                    }}
                  />
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <div className="text-center mt-5">
          <h6 className="mb-3">Secure Payment Processing</h6>
          <div className="d-flex align-items-center justify-content-center gap-3">
            <i className="ri-secure-payment-line fs-24 text-primary"></i>
            <i className="ri-paypal-line fs-24 text-primary"></i>
            <i className="ri-shield-check-line fs-24 text-primary"></i>
          </div>
        </div>
      </div>
      <Footer />
    </React.Fragment>
  );
}